import { LayoutGrid, Table, List, BarChart3 } from "lucide-react";
import { Button } from "../../../../components/ui/button";
import { cn } from "../../../../lib/utils";

const viewModes = [
  { key: "cards", icon: LayoutGrid, label: "Cartes" },
  { key: "table", icon: Table, label: "Tableau" },
  { key: "list", icon: List, label: "Liste" },
  { key: "analytics", icon: BarChart3, label: "Analytics" },
];

export default function ViewToggle({ currentView, onViewChange }) {
  return (
    <div className="flex items-center bg-gray-100 rounded-lg p-1">
      {viewModes.map(({ key, icon: Icon, label }) => (
        <Button
          key={key}
          variant={currentView === key ? "default" : "ghost"}
          size="sm"
          onClick={() => onViewChange(key)}
          className={cn(
            "transition-all duration-200",
            currentView === key
              ? "bg-white shadow-sm text-gray-900 border border-gray-200"
              : "hover:bg-gray-200 text-gray-600"
          )}
          title={label}
        >
          <Icon className="h-4 w-4" />
          <span className="ml-2 hidden sm:inline">{label}</span>
        </Button>
      ))}
    </div>
  );
}
